import Icon, {EditOutlined, SettingOutlined} from '@ant-design/icons'
import {Breadcrumb, Button, Image, Modal} from 'antd'
import {auth_updateOrg_Api, channel_add_Api, getChannelsByOrganization_Api,} from 'apis'
import {channelModel, organizationModel} from 'apis/model'
import {getId} from 'apis/model/base'
import ApiInfoForm from 'components/form/ApiInfoForm'
import PhotoSvg from 'components/Svgs/PhotoSvg'
import Toggle from 'components/Toggle'
import {Photo} from 'conts/imageBase64'
import {ROOT_URL} from 'envs/_current/config'
import _ from 'lodash'
import {LazyPagination} from 'modules/asyncCache/components/LazyPagination'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useContext} from 'react'
import {Provider, ReactReduxContext} from 'react-redux'
import {Link, Route, Switch, useParams, useRouteMatch} from 'react-router-dom'
import CreateChannelForm from 'views/CreateChannelForm'
import {DelayRender} from 'views/Shared/components/DelayRender'
import {gPaths} from 'views/AppLocals/configs'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NotificationActionTypes,} from 'views/AppLocals/factory/createNotification'
import {mapPathParam} from 'views/AppLocals/functions/routerHelper'
import OrganizationHome from 'views/Organization/components/OrganizationHome'
import OrganizationProvider from 'views/Organization/OrganizationProvider'
import ServerContext from 'views/Server/ServerContext'
import {getResponseItem, NullAsDefault} from 'views/Shared'
import {SubDomainContext} from '../SubDomain/SubDomainContext'
import {AboutUs} from './AboutUs/AboutUs'
import {News} from './Channel/News'
import {Contact} from './Contact/Contact'
import {ContactDetail} from './Contact/ContactDetail'
import SimpleContactForm from './Contact/SimpleContactForm'
import {Header} from './Header'
import {OrganizationLayout} from './OrganizationLayout'
import getLinkToDetail from 'helpers/getLinkToDetail'
import {successMessage} from "../AppLocals/factory/createMessageNotification";

export const OrganizationBanner = () => {
  const {item} = useContext(ServerContext)
  const t = useTranslate()

  return (
    <div className="w-full space-y-6 md:py-0">
      <div className="flex p-3 w-full h-full flex-col justify-center items-center space-y-10">
        <div className="max-w-2xl grid grid-cols-2 gap-3 py-6 text-color-300 font-bold">
          <Link
            className="py-3 px-6 flex justify-center items-center border rounded-full shadow-md"
            to={organizationModel.getLinkToSetting(item)}>
            {t('manage page')}
          </Link>
          <Link
            className="py-3 px-6 flex justify-center items-center border rounded-full shadow-md"
            to={organizationModel.getLinkToDetail(item)}>
            {t('main page')}
          </Link>
        </div>
        <div className="table border rounded-lg">
          <Image
            preview={false}
            width={160}
            height={160}
            src={organizationModel.getFullAvatarUrl(item) || '#'}
            className="object-contain w-full h-full rounded-lg border-white table"
            placeholder={<PhotoSvg/>}
            fallback={Photo}
          />
        </div>

        <div className="flex flex-col px-3 justify-center items-center space-y-3">
          <h2 className="p-3 title-font text-base md:text-lg font-bold">
            {item.title}
          </h2>
          <div className="text-base">{item.description}</div>
        </div>
      </div>
    </div>
  )
}

export const OrganizationStateless = ({id, children}) => {
  let {url} = useRouteMatch()
  const t = useTranslate()
  const history = useHistory()
  const {item: organization} = useContext(ServerContext)

  const {diff_root} = useContext(SubDomainContext)

  const {isLoading, handleAsyncAction: updatePrimaryOrg} = useAsyncAction({
    apiInfo: auth_updateOrg_Api,
    onSuccess: (result, {response}) => {
      successMessage(NotificationActionTypes.UPDATE, t)
      const {primary_org} = getResponseItem(response)
      if (!!diff_root) {
        window.location.replace(ROOT_URL + gPaths.organizationSettings_domain)
      } else {
        history.push({
          pathname: mapPathParam(gPaths.organizationSettings, {
            id: getId(primary_org),
          }),
        })
      }
    },
    onError: notifyOnError(t),
  })

  const setPrimaryOrg = (organization_id, callback = NullAsDefault) => {
    updatePrimaryOrg({organization_id})
  }

  if (url === '/') url = ''

  const renderHomeLayout = (children) => (
    <OrganizationLayout
      admin={
        !!organization &&
        !!_.get(organization, 'edit', false) && (
          <div className="p-2 px-3 background-100 font-bold flex space-x-2 items-center">
            <div>{t('admin')}</div>
            <div className="flex-1"/>
            <Button
              className="rounded-full"
              onClick={() => {
                setPrimaryOrg(_.get(organization, 'id'))
              }}
              icon={<SettingOutlined/>}>
              {t('setting')}
            </Button>
          </div>
        )
      }
      header={<Header url={url}/>}>
      <DelayRender time={300}>{children}</DelayRender>
    </OrganizationLayout>
  )

  return (
    <React.Fragment>
      {organization && (
        <Switch>
          <Route
            path={url + '/news'}
            render={() =>
              renderHomeLayout(
                <div>
                  <News/>
                  <Contact/>
                </div>
              )
            }
          />
          {/* <Route
            path={url + '/data'}
            render={() =>
              renderHomeLayout(
                <div>
                  <Data />
                  <Contact />
                </div>
              )
            }
          />*/}
          <Route
            path={url + '/about-us'}
            render={() =>
              renderHomeLayout(
                <div className="p-3 space-y-6">
                  <Breadcrumb className="font-light text-sm">
                    <Breadcrumb.Item>
                      <Link to={url}/>
                      {organizationModel.getTitle(organization)}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>{t('about us')}</Breadcrumb.Item>
                  </Breadcrumb>
                  <AboutUs/>
                </div>
              )
            }
          />
          <Route
            path={url + '/contact'}
            render={() =>
              renderHomeLayout(
                <div className="p-3 space-y-6">
                  <Breadcrumb className="font-light text-sm">
                    <Breadcrumb.Item>
                      <Link to={url}/>
                      {organizationModel.getTitle(organization)}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>{t('contact')}</Breadcrumb.Item>
                  </Breadcrumb>
                  <ContactDetail/>

                  <SimpleContactForm/>

                  <div className="mb-16"/>
                </div>
              )
            }
          />
          <Route
            path={url}
            render={() => renderHomeLayout(<OrganizationHome/>)}
          />
        </Switch>
      )}
    </React.Fragment>
  )
}
const FloatButton = ({type, id}) => {
  const history = useHistory()
  const t = useTranslate()
  return (
    <div
      style={{padding: '1em'}}
      className="fixed z-50 bottom-0 right-0 pointer-events-none">
      <Toggle>
        {(isToggle, toggle) => (
          <>
            <ReactReduxContext.Consumer>
              {({store}) => (
                <button
                  onClick={() => {
                    Modal.info({
                      closable: true,
                      maskClosable: true,
                      icon: false,
                      title: t('Choose the channel for posting'),
                      content: (
                        <div className="space-y-3">
                          <Button
                            onClick={() => toggle()}
                            className="rounded-full"
                            type="dashed"
                            block>
                            {t('Create new channel')}
                          </Button>
                          <Provider store={store}>
                            <LazyPagination
                              apiInfo={getChannelsByOrganization_Api}
                              query={{
                                ':id': id,
                              }}
                              renderItem={(item, index) => {
                                return (
                                  <div
                                    key={index}
                                    data-effect="ripple"
                                    onClick={() => {
                                      Modal.destroyAll()
                                      history.push(
                                        getLinkToDetail(item) +
                                        `?initialCurrent=posting`
                                      )
                                    }}
                                    className="verticalList__small ">
                                    <div
                                      className="p-3 block cursor-pointer border border-gray-100 hover:border-gray-300  background-100  rounded-lg">
                                      <div className="flex items-center mb-2">
                                        <a className="font-semibold flex-1 text-lg">
                                          {channelModel.getTitle(item)}
                                        </a>
                                      </div>
                                      {item.description && (
                                        <div className="">
                                          {item.description}
                                        </div>
                                      )}
                                      <div className="mt-3">
                                        <span className="mr-3">
                                          <span className="font-semibold mr-1">
                                            {item.total_members}
                                          </span>
                                          {t('members')}
                                        </span>
                                        <span className="mr-3">
                                          <span className="font-semibold mr-1">
                                            {item.total_articles}
                                          </span>
                                          {t('articles')}
                                        </span>
                                      </div>
                                      <div className="flex flex-wrap text-sm">
                                        {_.get(item, 'categories', []).map(
                                          (e, i) => {
                                            return (
                                              <span
                                                key={i}
                                                className="mr-2 border border-gray-300 mt-2 px-2 background rounded-lg">
                                                {e.name}
                                              </span>
                                            )
                                          }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )
                              }}></LazyPagination>
                          </Provider>
                        </div>
                      ),
                    })
                  }}
                  data-effect="ripple"
                  style={{
                    marginBottom: 'var(--header-height)',
                  }}
                  className="w-12 flex items-center justify-center bg-primary text-white shadow-xl h-12 rounded-full pointer-events-auto border border-white">
                  <Icon component={EditOutlined}/>
                </button>
              )}
            </ReactReduxContext.Consumer>
            <Modal
              onCancel={toggle}
              open={isToggle}
              destroyOnHidden
              footer={null}>
              <ApiInfoForm
                onSuccess={([__, data]) => {
                  Modal.destroyAll()
                  history.push(
                    getLinkToDetail(data.response.data) +
                    `?initialCurrent=posting`
                  )
                }}
                apiInfo={channel_add_Api}
                onPreSubmit={(values) => {
                  return {
                    ...values,
                    privacy: values.privacy === '1' ? 2 : 1,
                  }
                }}
                initialValues={{
                  owner_id: id,
                  owner_type: type,
                }}>
                {({...props}) => {
                  return <CreateChannelForm {...props} />
                }}
              </ApiInfoForm>
            </Modal>
          </>
        )}
      </Toggle>
    </div>
  )
}
export default () => {
  const {id} = useParams()
  return (
    <React.Fragment key={id}>
      <OrganizationProvider {...{id}}>
        {React.useMemo(
          () => (
            <OrganizationStateless
              {...{
                id,
              }}
            />
          ),
          [id]
        )}
        <ServerContext.Consumer>
          {({item}) =>
            item && item.edit ? (
              <FloatButton {...{type: 'organization', id}} />
            ) : null
          }
        </ServerContext.Consumer>
      </OrganizationProvider>
    </React.Fragment>
  )
}
